import { InjectionToken, QueryList } from '@angular/core';

import { Calculation } from '../../../models/feed-profit.model';

export interface BaselineTableHost {
  baselineFeedersComponent?: BaselineFeedersHost;
}

export interface BaselineFeedersHost {
  genders: string;
  calculation: Calculation;
  tableComponents: QueryList<BaselineTableHost>;
  calculatedTableComponent: unknown;
  totalTableTotalAverages: number;
}

export const BASELINE_FEEDERS_HOST = new InjectionToken<BaselineFeedersHost>(
  'BASELINE_FEEDERS_HOST',
);

export const BASELINE_TABLE_HOST = new InjectionToken<BaselineTableHost>('BASELINE_TABLE_HOST');
